import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

/**
 * Shown once a blueprint is approved and saved: the hand-off from
 * "Export" to "Check My Build". Nothing runs here — it opens the project's
 * Second Pair of Eyes page, where selecting the Snapshot runs the check.
 */
export default function SecondPairOfEyesCard({ sessionId, blueprintVersion }) {
  const navigate = useNavigate();
  if (!sessionId) return null;

  return (
    <Paper
      elevation={0}
      sx={{ p: 3, mt: 2, boxShadow: "0 6px 20px rgba(0, 0, 0, 0.09)", borderLeft: "4px solid", borderColor: "primary.main" }}
      data-testid="second-pair-of-eyes-card"
    >
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={2}>
        <Box>
          <Typography variant="overline" color="primary" fontWeight={700}>
            Step 7 · Second Pair of Eyes
          </Typography>
          <Typography variant="h6" fontWeight={700}>
            Built it? Check it against this Blueprint{blueprintVersion ? ` (Version ${blueprintVersion})` : ""}.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 620 }}>
            When your coding tool finishes, it generates <strong>onepass-build-snapshot.json</strong> from the
            instructions in the Developer Package. Select that file and OnePass compares the completed build to
            what was approved — no source code needed.
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<VisibilityOutlinedIcon />}
          onClick={() => navigate(`/build/projects/${encodeURIComponent(sessionId)}/second-pair-of-eyes`)}
          sx={{ whiteSpace: "nowrap" }}
        >
          Check My Build
        </Button>
      </Stack>
    </Paper>
  );
}
